import Vue from 'vue'
import { HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import {
  RESET_SETTINGS,
  LOAD_SETTINGS,
  UPDATE_SETTING,
  LOAD_EXCHANGE_INFO,
  LOAD_STATS,
  LOAD_ACTIONS_STATS,
} from "../const/settings";

export default {
  namespaced: true,
  state: {
    exchangeName: 'Обменник',
    defaults: {
      roles: {
        superadmin: 'Суперадмин',
        admin: 'Админ',
        support: 'Поддержка',
        partner: 'Партнер',
      },
      paymentSystems: {
        card: 'Карты',
        sbp: 'СБП',
        sim: 'Пополнение телефона',
        bank_account: 'Банковский счет',
        qr: 'QR',
        foreign_card: 'Зарубежная карта',
        foreign_sbp: 'Зарубежный СБП',
        interbank: 'Внутребанк',
      },
      handlers: ['saudi', 'emirates', 'honey', 'bridge'],
      statuses: {
        canceled: 'Отменена',
        created: 'Добавлена',
        requisites_added: 'Реквизиты получены',
        requisites_sent: 'Реквизиты отправлены',
        requisites_not_found: 'Отсутствуют реквизиты',
        marked_paid: 'Помечена оплаченной',
        paid: 'Помечена оплаченной',
        claim: 'Претензия',
        wait_finish: 'Завершение',
        finished: 'Завершена',
        finish_error: 'Ошибка завершения',
        error: 'Ошибка',
        cancel_error: 'Ошибка отмены',
        wait_cancel: 'Отмена',
      }
    },
    balance: {
      value: 0,
      updated: '',
    },
    wallet: {
      value: '',
      updated: 0
    },
    stats: {
      general: {},
      paymentSystems: [],
    },
    actionsStats: [],
    handlersColors: {
      honey: '#be9c13',
      bridge: '#3b3936',
      saudi: '#2cc89b',
      emirates: '#c82c49',
    },
  },
  getters: {
    settings: state => state.settings,
    workStatus: state => state.workStatus,
    roles: state => state.defaults.roles,
    paymentSystems: state => state.defaults.paymentSystems,
    handlers: state => state.defaults.handlers,
    balance: state => state.balance,
    wallet: state => state.wallet,
    partner: state => state.partner,
    partnerProfitPercent: state => state.partnerProfitPercent,
    exchangeName: state => state.exchangeName,
    statuses: state => state.defaults.statuses,
    stats: state => state.stats,
    actionsStats: state => state.actionsStats,
    handlersColors: state => state.handlersColors,
  },
  actions: {
    [LOAD_SETTINGS]: async ({ dispatch }) => {
      const request = await dispatch(HTTP_GET, {
        method: LOAD_SETTINGS,
        namespace: 'settings',
        no_commit: true,
      }, { root: true });
      return request;
    },
    [LOAD_EXCHANGE_INFO]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_EXCHANGE_INFO,
        namespace: 'settings',
      }, { root: true });
    },
    [UPDATE_SETTING]: async ({ dispatch }, data) => {
      const request = await dispatch(HTTP_PUT, {
        method: UPDATE_SETTING,
        namespace: 'settings',
        no_commit: true,
        body: data,
      }, { root: true });
      return request;
    },
    [LOAD_STATS]: async ({ dispatch }, { from, to }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_STATS,
        namespace: 'settings',
        params: { from, to },
      }, { root: true });
    },
    [LOAD_ACTIONS_STATS]: async ({ dispatch }, { from, to }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_ACTIONS_STATS,
        namespace: 'settings',
        params: { from, to },
      }, { root: true });
    },
  },
  mutations: {
    [LOAD_SETTINGS]: (state, { data }) => {
      for (const settingName of Object.keys(data)) {
        Vue.set(state, settingName, data[settingName]);
      }
    },
    [LOAD_STATS]: (state, { data }) => {
      if (data) {
        Vue.set(state, 'stats', data);
      }
    },
    [LOAD_ACTIONS_STATS]: (state, { data }) => {
      Vue.set(state, 'actionsStats', data);
    },
    [LOAD_EXCHANGE_INFO]: (state, { data }) => {
      Vue.set(state.balance, 'value', data.balance.value);
      Vue.set(state.balance, 'updated', data.balance.updated);
      Vue.set(state.wallet, 'value', data.wallet.value);
      Vue.set(state.wallet, 'updated', data.wallet.updated);
    },
    [RESET_SETTINGS]: (state) => {
      Vue.set(state, 'balance', {
        value: 0,
        updated: '',
      });
      Vue.set(state, 'wallet', '');
      Vue.set(state, 'stats', {
        total: {},
        finished: {},
        canceled: {},
      });
      Vue.set(state, 'actionsStats', []);
    },
  },
};
